import { memo } from "react"

type Row = {
  mobiles: {
    globalid: string
  }[]
}

type CarsInFleet = {
  row: Row
}

const CarsInFleetColumn = memo(({ row }: CarsInFleet) => {
  return row?.mobiles?.map((mobile) => mobile.globalid).join(', ') ?? ''
})

export default CarsInFleetColumn
